import styled from 'styled-components';
import { 
    Button,
} from '@mui/material';

export const Container = styled.div`
    position: 'relative'
`;

export const ActiveButton = styled(Button)`
    && {
        margin: 10px 10px 10px 0px;
        height: 40px;
        background-color: ${props => props.active === 1 ? '#585858' : 'green' };
    }
`;

export const MaintenanceButton = styled(Button)`
    && {
        margin: 10px;
        height: 40px;
        background-color: ${props => props.maintenance === 1 ? 'darkblue' : '#0363c3' };
    }    
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: start;
  align-items: start;
  transition: 2s;
`;